<template>
  <div class="row container_card">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="col-12 col-xl-4 list_body">
        <CCard bodyWrapper @click="nextRoute(0)">
          <div style="width: 30%; height: 100%">
            <img
              :src="baseUrl + '' + content[0].icon.enable.data"
              alt="VOCABULARY"
              srcset=""
              class="img_list"
            />
          </div>
          <div style="width: 70%">
            <p class="font_list" style="color: #349e86">
              {{ checkLanguage(content[0].title) }}
            </p>
          </div>
        </CCard>
      </div>
      <div class="col-12 col-xl-4 list_body">
        <CCard bodyWrapper @click="nextRoute(1)">
          <div style="width: 30%; height: 100%">
            <img
              :src="baseUrl + '' + content[1].icon.enable.data"
              alt="NOTE"
              srcset=""
              class="img_list"
            />
          </div>
          <div style="width: 70%">
            <p class="font_list" style="color: #f1b205">
              {{ checkLanguage(content[1].title) }}
            </p>
          </div>
        </CCard>
      </div>
      <div class="col-12 col-xl-4 list_body">
        <CCard bodyWrapper @click="nextRoute(2)">
          <div style="width: 30%; height: 100%">
            <img
              :src="baseUrl + '' + content[2].icon.enable.data"
              alt="TEST"
              srcset=""
              class="img_list"
            />
          </div>
          <div style="width: 70%">
            <p class="font_list" style="color: #cc0000">
              {{ checkLanguage(content[2].title) }}
            </p>
          </div>
        </CCard>
      </div>
    </template>
  </div>
</template>

<script>
import LoadingMDL from '@/components/loading/LoadingMDL';
import {mapGetters} from 'vuex';
export default {
  name: 'List',
  components: {
    LoadingMDL,
  },
  props: {
    items: Array,
    lang: String,
    allContent: Object,
  },
  data() {
    return {
      content: [],
      loading: true,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      code: '',
      section: '',
    };
  },
  methods: {
    nextRoute: function (index) {
      if (index == 2) {
        console.log(this.allContent.menuLock);
        if (this.allContent.menuLock[11].lock == false) {
          let templateCode = this.allContent.menuLock[11].code;
          let bodyOfNextRoute = {
            // code: "605418cb883ae722ba1b0c5f",
            // section: "testing",
            code: this.code,
            section: this.section,
            templateCode: templateCode,
            type: 'posttest',
          };
          this.$store.dispatch(
            'template/fectchResultTestOpen',
            bodyOfNextRoute
          );
          return;
        }
        // if lesson not complete all
        let body = {
          detail: 'You have to complete all the test.',
        };
        this.$emit('nextRoute', body);
        return;
      }
      this.$emit('nextRoute', index);
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.lang) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error!!');
        }
      } else {
        console.log('change language is error!!');
      }
    },
  },
  computed: {
    ...mapGetters({
      getStatus: 'template/getStatusTest',
    }),
  },
  watch: {
    getStatus: function (val) {
      if (val.code === 20000 && val.data.type == 'posttest') {
        let body = {
          lock: val.data.checkLock,
          detail: val.data ? 'Post test has been closed.' : '',
        };
        this.$emit('nextRoute', body);
      }
    },
  },
  created() {
    this.code = this.$store.getters['necessary/getLerningCourse']._id;
    this.section = this.$store.getters['necessary/getUserCourseSection'];
  },
  mounted() {
    this.content = this.items.slice(10, 13);
    this.loading = false;
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.font_list {
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: center;
  font-family: 'Roboto';
}
::v-deep .card {
  border-radius: 40px;
  height: 200px;
  width: 430px;
  margin: 0;
}

::v-deep .card-body {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.container_card {
  cursor: pointer;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img_list {
  height: 100%;
}
.list_body {
  width: 100%;
}

@media screen and (min-width: 300px) and (max-width: 600px) {
  .font_list {
    font-size: 25px;
  }

  ::v-deep .card {
    border-radius: 40px;
    height: 120px !important;
    width: auto;
    margin: 5% auto;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .font_list {
    font-size: 25px;
  }

  .container_card {
    width: 90%;
    margin: 50px auto !important;
  }

  .img_list {
    width: 60%;
  }

  ::v-deep .card {
    border-radius: 40px;
    height: 150px !important;
    width: 40rem !important;
    margin: 15px auto;
  }
}

@media screen and (min-width: 1025px) {
  .container_card {
    width: 90%;
  }

  ::v-deep .card {
    border-radius: 40px;
    height: 150px;
    width: auto;
    margin: 15px auto;
  }
}
</style>
